<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Budjet ma'lumot turi" prop="info_type">
                <el-select style="width: 100%" size="large" v-model="form.type">
                  <el-option v-for="{type, title} in infoTypes" :key="type" :value="type" :label="title"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Lotincha" prop="title.uz_lat">
                <el-input size="large" class="form-input" v-model="form.title.uz_lat"
                          type="text"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Krilcha" prop="title.uz_cyr">
                <el-input size="large" class="form-input" v-model="form.title.uz_cyr"
                          type="text"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ruscha" prop="title.ru">
                <el-input size="large" class="form-input" v-model="form.title.ru"
                          type="text"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Inglizcha" prop="title.en">
                <el-input size="large" class="form-input" v-model="form.title.en"
                          type="text"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Qoraqalpoqcha" prop="title.kr">
                <el-input size="large" class="form-input" v-model="form.title.kr"
                          type="text"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "StateBudgetForm",
  data() {
    return {
      loading: false,
      infoTypes: [{type: 'INCOME', title: 'Daromadlar'}, {type: 'EXPENSE', title: 'Xarajatlar'}],
      form: {
        title: {
          uz_cyr: null,
          uz_lat: null,
          kr: null,
          en: null,
          ru: null
        },
        type: "INCOME",
        parent_id: null
      },
      rules: {
        title: [{
          uz_cyr: [{required: true, message: "Majburiy maydon", trigger: 'blur'}],
          uz_lat: [{required: true, message: "Majburiy maydon", trigger: 'blur'}],
          kr: [{required: true, message: "Majburiy maydon", trigger: 'blur'}],
          en: [{required: true, message: "Majburiy maydon", trigger: 'blur'}],
          ru: [{required: true, message: "Majburiy maydon", trigger: 'blur'}],
        }],
        type: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
      }
    }
  },
  methods: {
    getStateBudgetIndicatorById() {
      this.loading = true
      this.$http.get(`api/v1/state-budget-indicators/${this.form.id}`)
          .then(({data}) => {
            this.form = data
          })
          .catch(({response}) => {
            ElNotification.error({
              message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
            })
          }).finally(() => {
        this.loading = false
      })
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {...this.form}
          if (this.form.id) {
            http = this.$http.put(`/api/v1/state-budget-indicators/${this.form.id}`, formData);
          } else {
            http = this.$http.post('/api/v1/state-budget-indicators', formData);
          }

          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message || "Iltimos, qayta urinib ko'ring.",
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
  },
  mounted() {
    if (this.$route.params.parent) {
      this.form.parent_id = parseInt(this.$route.params.parent);
    }
    if (this.$route.params.id) {
      this.form.id = parseInt(this.$route.params.id);
      this.getStateBudgetIndicatorById()
    }
  }
}
</script>

<style scoped>

</style>
